import { Action } from '@ngrx/store';
import { type } from '../util';
import { CampaignTemplatesModel } from '../models/engage/campaign-templates.model';
import { CampaignType } from '../models/engage/campaign-details.model';

export const ActionTypes = {
  FETCH_CAMPAIGN_TEMPLATES:                                             type('[Campaign Engage] Fetch Templates'),
  FETCH_CAMPAIGN_TEMPLATES_FAILURE:                                     type('[Campaign Engage] Fetch Templates Failure'),
  FETCH_CAMPAIGN_TEMPLATES_SUCCESS:                                     type('[Campaign Engage] Fetch Templates Success'),
  SELECT_TEMPLATE:                                                      type('[Campaign Engage] Select CEv2 Template'),
  SELECT_TEMPLATE_SUCCESS:                                              type('[Campaign Engage] Fetched Template Details'),
  SELECT_TEMPLATE_FAILURE:                                              type('[Campaign Engage] Failed to Fetch Template Details'),
  UPDATE_CAMPAIGN_CUSTOMIZATIONS:                                       type('[Campaign Engage] Update campaign customizations'),
  UPDATE_REWARD_CAMPAIGN:                                               type('[Campaign Engage] Update reward campaign'),
  UPDATE_REWARD_CAMPAIGN_DATES:                                         type('[Campaign Engage] Update reward campaign dates'),
  FETCH_CAMPAIGN_DETAILS:                                               type('[Campaign Engage] Fetch Campaign Details'),
  FETCH_CAMPAIGN_DETAILS_SUCCESS:                                       type('[Campaign Engage] Fetch Campaign Details Success'),
  FETCH_CAMPAIGN_DETAILS_FAILURE:                                       type('[Campaign Engage] Fetch Campaign Details Failure'),
  FETCH_AUTOMATION_DETAILS_SUCCESS:                                     type('[Campaign Engage] Fetch Automation Details Success'),
  CANCEL_CURRENT_REWARD:                                                        type('[Campaign Engage] Cancel Reward'),
  CREATE_CAMPAIGN:                                                      type('[Campaign Engage] Create Campaign'),
  CREATE_CAMPAIGN_FAILURE:                                              type('[Campaign Engage] Create Campaign Failure'),
  CREATE_CAMPAIGN_SUCCESS:                                              type('[Campaign Engage] Create Campaign Success'),
  UPDATE_CAMPAIGN:                                                      type('[Campaign Engage] Update Campaign'),
  UPDATE_CAMPAIGN_FAILURE:                                              type('[Campaign Engage] Update Campaign Failure'),
  UPDATE_CAMPAIGN_SUCCESS:                                              type('[Campaign Engage] Update Campaign Success'),
  CANCEL_CAMPAIGN:                                                      type('[Campaign Engage] Cancel Campaign'),
  CANCEL_CAMPAIGN_FAILURE:                                              type('[Campaign Engage] Cancel Campaign Failure'),
  CANCEL_CAMPAIGN_SUCCESS:                                              type('[Campaign Engage] Cancel Campaign Success'),
  UPDATE_SENDING_OPTION:                                                type('[Campaign Engage] Update Sending Option'),
  UPDATE_EVENT_CAMPAIGN:                                                type('[Campaign Engage] Update event campaign'),
  FETCH_REWARD_ANALYTICS_FAILURE:                                       type('[Campaign Engage] Fetch Reward Analytics Failure'),
  FETCH_REWARD_ANALYTICS_SUCCESS:                                       type('[Campaign Engage] Fetch Reward Analytics Success'),
  UPDATE_SELECTED_EMAIL_CATEGORIES:                                     type('[Campaign Engage] Update Selected Email Categories'),
};

export class FetchCampaignTemplates implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_TEMPLATES;
  constructor(public campaignType: CampaignType) { }
}

export class FetchCampaignTemplatesSuccess implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_TEMPLATES_SUCCESS;
  constructor(public payload: CampaignTemplatesModel[] = []) { }
}

export class FetchCampaignTemplatesFailure implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_TEMPLATES_FAILURE;
  constructor(public campaignType: CampaignType, public payload: any = '') { }
}

export class SelectTemplate implements Action {
  public type = ActionTypes.SELECT_TEMPLATE;
  constructor(public payload: any = {}) { }
}
export class SelectTemplateSuccess implements Action {
  public type = ActionTypes.SELECT_TEMPLATE_SUCCESS;
  constructor(public payload: any = {}) { }
}
export class SelectTemplateFailure implements Action {
  public type = ActionTypes.SELECT_TEMPLATE_FAILURE;
  constructor(public payload: any = {}) { }
}

export class FetchCampaignDetails implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_DETAILS;
  constructor(public payload: any = {}) { }
}
export class FetchCampaignDetailsSuccess implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_DETAILS_SUCCESS;
  constructor(public payload: any = {}) { }
}
export class FetchCampaignDetailsFailure implements Action {
  public type = ActionTypes.FETCH_CAMPAIGN_DETAILS_FAILURE;
  constructor(public payload: any = {}) { }
}
export class FetchAutomationDetailsSuccess implements Action {
  public type = ActionTypes.FETCH_AUTOMATION_DETAILS_SUCCESS;
  constructor(public payload: any = {}) { }
}

export class UpdateCampaignCustomizations implements Action {
  public type = ActionTypes.UPDATE_CAMPAIGN_CUSTOMIZATIONS;
  constructor(public payload: any = {}) { }
}

export class UpdateRewardCampaign implements Action {
  public type = ActionTypes.UPDATE_REWARD_CAMPAIGN;
  constructor(public payload: any = {}) { }
}

export class UpdateRewardCampaignDates implements Action {
  public type = ActionTypes.UPDATE_REWARD_CAMPAIGN_DATES;
  constructor(public payload: any = {}) { }
}

export class UpdateEventCampaign implements Action {
  public type = ActionTypes.UPDATE_EVENT_CAMPAIGN;
  constructor(public payload: any = {}) { }
}

export class CreateCampaign implements Action {
  public type = ActionTypes.CREATE_CAMPAIGN;
}

export class CreateCampaignFailure implements Action {
  public type = ActionTypes.CREATE_CAMPAIGN_FAILURE;
  constructor(public err: string = '') { }
}

export class CreateCampaignSuccess implements Action {
  public type = ActionTypes.CREATE_CAMPAIGN_SUCCESS;
  constructor(public campaignID: string = '') { }
}

export class UpdateCampaign implements Action {
  public type = ActionTypes.UPDATE_CAMPAIGN;
}

export class UpdateCampaignFailure implements Action {
  public type = ActionTypes.UPDATE_CAMPAIGN_FAILURE;
  constructor(public err: string = '') { }
}

export class UpdateCampaignSuccess implements Action {
  public type = ActionTypes.UPDATE_CAMPAIGN_SUCCESS;
  constructor(public payload: {campaignID: string, update: boolean}) { }
}

export class CancelCurrentReward implements Action {
  public type = ActionTypes.CANCEL_CURRENT_REWARD;
  constructor(public payload: any = {}) { }
}

export class CancelCampaign implements Action {
  public type = ActionTypes.CANCEL_CAMPAIGN;
  constructor(public payload: any = {}) { }
}

export class CancelCampaignFailure implements Action {
  public type = ActionTypes.CANCEL_CAMPAIGN_FAILURE;
  constructor(public err: string = '') { }
}

export class CancelCampaignSuccess implements Action {
  public type = ActionTypes.CANCEL_CAMPAIGN_SUCCESS;
}

export class UpdateSendingOption implements Action {
  public type = ActionTypes.UPDATE_SENDING_OPTION;
  constructor(public payload: any = {}) { }
}

export class FetchRewardAnalyticsFailure implements Action {
  public type = ActionTypes.FETCH_REWARD_ANALYTICS_FAILURE;
  constructor(public payload: any = '') { }
}

export class FetchRewardAnalyticsSuccess implements Action {
  public type = ActionTypes.FETCH_REWARD_ANALYTICS_SUCCESS;
  constructor(public payload: any = {}) { }
}

export class UpdateSelectedEmailCategories implements Action {
  public type = ActionTypes.UPDATE_SELECTED_EMAIL_CATEGORIES;
  constructor(public payload: string[]) { }
}

export type Actions =
  | FetchCampaignTemplates
  | FetchCampaignTemplatesSuccess
  | FetchCampaignTemplatesFailure
  | SelectTemplate
  | SelectTemplateSuccess
  | SelectTemplateFailure
  | UpdateCampaignCustomizations
  | UpdateRewardCampaign
  | UpdateRewardCampaignDates
  | FetchCampaignDetails
  | FetchCampaignDetailsSuccess
  | FetchCampaignDetailsFailure
  | FetchAutomationDetailsSuccess
  | CreateCampaign
  | CreateCampaignFailure
  | CreateCampaignSuccess
  | UpdateCampaign
  | UpdateCampaignFailure
  | UpdateCampaignSuccess
  | CancelCurrentReward
  | CancelCampaign
  | CancelCampaignFailure
  | CancelCampaignSuccess
  | UpdateSendingOption
  | FetchRewardAnalyticsFailure
  | FetchRewardAnalyticsSuccess
  | UpdateSelectedEmailCategories
  | UpdateEventCampaign;
